import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const PLUGINS = [remarkGfm];

// A GFM table is the one block that can be wider than its column, so it gets its
// own scroller rather than pushing the layout around.
const COMPONENTS = {
  // `node` is react-markdown's own AST handle; spreading it onto the <table>
  // would trip React's unknown-DOM-prop warning.
  table: ({ ...props }) => (
    <div className="markdown-table-scroll">
      <table {...props} />
    </div>
  ),
};

/**
 * react-markdown with the plugin set every view shares: GFM, so tables,
 * strikethrough, task lists and bare URLs render the way a model meant them.
 * Import this rather than react-markdown directly — a view that reaches past it
 * silently loses tables.
 */
export default function Markdown({ children, ...rest }) {
  return (
    <div className="markdown-content">
      <ReactMarkdown remarkPlugins={PLUGINS} components={COMPONENTS} {...rest}>
        {children}
      </ReactMarkdown>
    </div>
  );
}
